import { BreadCrumbsRoot, BreadCrumbsContainer, Arrow } from "./BreadCrumbs.styles"
import { TranslationKeys } from "locales/translationKeys"
import { Text } from "components/Text"
import useTranslation from "next-translate/useTranslation"

type BreadCrumbsProps = {
    crumbs: TranslationKeys[]
}

export const BreadCrumbs = ({ crumbs }: BreadCrumbsProps) => {
    const { t } = useTranslation()
    return (
        <BreadCrumbsRoot>
            {
                crumbs.map((crumb, index) => (
                    <BreadCrumbsContainer key={index}>
                        <Text size={{'@initial': 'tiny', '@bp2': 'caption'}}>{t(crumb)}</Text>
                        {(index < crumbs.length - 1) && <Arrow size='3' name='angle-right' />}
                    </BreadCrumbsContainer>
                ))
            }
        </BreadCrumbsRoot>
    )
}